import React, { useState, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import Box from '../Box';
import Typography from '../Typography';
import DatePickerBase from '../DatePickerBase';
import { makeStyles } from '../styles';
import { CalendarIcon } from '../icons';
const useStyles = makeStyles(({ palette, spacing, zIndex }) => ({
    inputRoot: {
        cursor: 'pointer',
        minWidth: 100,
    },
    calanderIcon: {
        height: 20,
        width: 20,
        maxHeight: 20,
        maxWidth: 20,
        minHeight: 20,
        minWidth: 20,
        marginLeft: spacing(),
        color: palette.secondary.main,
    },
    popper: {
        zIndex: zIndex.leafletMax + 100,
    },
    placeholder: {
        color: palette.text.secondary,
    },
}));
const CustomInput = forwardRef(({ value, onClick, inputClassName, placeholder }, ref) => {
    const classes = useStyles();
    return (React.createElement(Box, { ref: ref, className: classNames(inputClassName, classes.inputRoot), onClick: onClick, alignItems: "center", width: "100%", justifyContent: "space-between" },
        React.createElement(Typography, { className: classNames({ [classes.placeholder]: !value }), variant: "body2" }, value || placeholder),
        React.createElement(CalendarIcon, { className: classes.calanderIcon })));
});
function DatePickerPopup({ inputClassName, startDate, onChange, placeholder, }) {
    const classes = useStyles();
    // initialise with a passed in start date undefined which will show the placeholder
    const [selectedDate, setSelectedDate] = useState(() => startDate ? new Date(startDate) : undefined);
    const handleSelection = (date) => {
        setSelectedDate(date);
        onChange(new Date(date));
    };
    return (React.createElement(DatePickerBase
    // @ts-ignore
    , { 
        // @ts-ignore
        popperClassName: classes.popper, popperContainer: ({ children }) => createPortal(children, document.body), dateFormat: "yyyy-MM-dd", onChange: handleSelection, selected: selectedDate, placeholderText: placeholder, openToDate: startDate ? new Date(startDate) : new Date(), customInput: React.createElement(CustomInput, { inputClassName: inputClassName }) }));
}
export default DatePickerPopup;
//# sourceMappingURL=DatePickerPopup.js.map